import React, { ChangeEvent, useEffect, useState } from "react";
import { ErrorMessage, Field, useField, useFormikContext } from "formik";
import { useReactiveVar } from "@apollo/client";
import { currencySingVar } from "@me-team/host/main/globalVar/state";

interface PriceInputProps {
    name: string;
    placeholder: string;
    initialValue?: number;
    id: string;
    disabled?: boolean;
    isRadioButton?: boolean;
}

const PriceInputSale: React.FC<PriceInputProps> = ({
    name,
    placeholder,
    initialValue,
    id,
    disabled,
    isRadioButton,
}) => {
    const currencySing = useReactiveVar(currencySingVar);
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const [field, meta] = useField(name);
    const [price, setPrice] = useState("");
    const [manualField] = useField(name.replace(/\.amount$/, ".isAmountManuallyEdited"));
    const isAmountManuallyEdited = manualField.value;

    useEffect(() => {
        if (isRadioButton) {
            if (!isAmountManuallyEdited) {
                if (initialValue !== undefined && initialValue !== null) {
                    setPrice(initialValue.toFixed(2));
                } else {
                    setPrice("");
                }
            }
        } else {
            if (initialValue !== undefined && initialValue !== null) {
                setPrice(initialValue.toFixed(2));
            } else {
                setPrice("");
            }
        }
    }, [initialValue, isAmountManuallyEdited, isRadioButton]);

    const handlePriceChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const value = e.target.value.trim();
        const regex = /^(?!0\d)\d{0,6}(\.\d{0,2})?$/;
        if (regex.test(value) || value === "") {
            setPrice(value);
        }
    };

    const handleBlurPrice = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.trim();
        if (value === "") {
            setPrice("");
            setFieldTouched(name, true, true);
            setFieldValue(name, null);
        } else {
            const numericPrice = parseFloat(value);

            if (!isNaN(numericPrice)) {
                if (numericPrice < 0.01) {
                    const minPrice = 0.01;
                    setPrice(minPrice.toFixed(2));
                    setFieldValue(name, minPrice);
                } else {
                    const formattedPrice = numericPrice.toFixed(2);
                    setPrice(formattedPrice);
                    setFieldValue(name, parseFloat(formattedPrice));
                }

                if (isRadioButton) {
                    const manualFieldName = name.replace(/\.amount$/, ".isAmountManuallyEdited");
                    setFieldValue(manualFieldName, true);
                }
            } else {
                setPrice("");
                setFieldValue(name, null);
            }
        }
    };

    return (
        <div className="position-relative">
            <Field
                name={name}
                type="text"
                id={id}
                placeholder={placeholder}
                value={price !== null ? price.toString() : ""}
                className={`form-control ${isRadioButton ? "ps-7" : ""} ${
                    meta.touched && meta.error ? "is-invalid" : ""
                }`}
                onBlur={handleBlurPrice}
                onChange={handlePriceChange}
                disabled={disabled}
            />
            <i
                className={`position-absolute fs-7 end-0 top-50 translate-middle-y text-dark me-2 pe-3
             ${meta.touched && meta.error ? "d-none" : ""}`}
            >
                {currencySing}
            </i>
            <ErrorMessage name={name}>{(msg) => <div className="invalid-feedback">{msg}</div>}</ErrorMessage>
        </div>
    );
};

export default PriceInputSale;
